import { useMemo } from "react";

import { AUTH_ROLES } from "api/common/types/auth.types";
import {
  ECR_FILE_TYPES,
  ECR_PROCESS_LOCATIONS,
  ECR_STATUSES,
  ECR_TYPES,
} from "api/memberPortal/ecr/ecrOptions.types";
import { withForm } from "components/Forms/AppForm";
import { useAuth } from "hooks/useAuth";

import { ecrFormDefaultValues } from "./ecrFormDefaultValues";

const options = {
  processLocations: Object.values(ECR_PROCESS_LOCATIONS),
  types: Object.values(ECR_TYPES),
  documentTypes: Object.values(ECR_FILE_TYPES),
};

const EcrCommentInfoSection = withForm({
  defaultValues: ecrFormDefaultValues,
  render: function Render({ form }) {
    const { permissions } = useAuth();

    const statusOptions = useMemo(() => {
      const isValidatorOrNiap =
        (permissions.role_type === AUTH_ROLES.VALIDATOR &&
          (permissions.is_senior || permissions.is_lead)) ||
        permissions.role_type === AUTH_ROLES.NIAP;

      if (isValidatorOrNiap) {
        return Object.values(ECR_STATUSES);
      }
      return [
        ECR_STATUSES.DRAFT,
        ECR_STATUSES.PROPOSED,
        ECR_STATUSES.CONCEALED,
      ];
    }, [permissions]);

    return (
      <>
        <form.FormSection title="Comment Info" columns={2}>
          {/* Comment Title */}
          <form.AppField name="title">
            {(field) => <field.TextInput label="Comment Title" />}
          </form.AppField>

          {/* Process Location */}
          <form.AppField name="process_location">
            {(field) => (
              <field.SelectField
                options={options.processLocations}
                label="Process Location"
                required={true}
                containerProps={{
                  sx: {
                    flex: "1 1 100%",
                  },
                }}
              />
            )}
          </form.AppField>

          {/* Comment Type */}
          <form.AppField name="type">
            {(field) => (
              <field.SelectField
                options={options.types}
                label="Comment Type"
                required={true}
              />
            )}
          </form.AppField>

          {/* Comment Status */}
          <form.AppField name="status">
            {(field) => (
              <field.SelectField
                options={statusOptions}
                label="Comment Status"
                required={true}
              />
            )}
          </form.AppField>

          {/* Document Types */}
          <form.AppField name="documentTypes">
            {(field) => (
              <field.MultiSelect
                options={options.documentTypes}
                label="Document Types"
                required={true}
              />
            )}
          </form.AppField>

          {/* Cite */}
          <form.AppField name="cite">
            {(field) => (
              <field.TextInput
                required={true}
                label="Cite (Page & Paragraph)"
              />
            )}
          </form.AppField>
        </form.FormSection>
      </>
    );
  },
});

export default EcrCommentInfoSection;
